import { colorTheme } from '../colors';

export const ELEVATED = {
  regular: `0px 0.375rem 0.625rem 0px ${colorTheme.elevated.regular}`,
  strong: `0px 0.375rem 0.875rem 0px ${colorTheme.elevated.strong}`,
  hard: `0px 0.375rem 1rem 0px ${colorTheme.elevated.hard}`,
} as const;
